'use strict';

angular.module('app')
  .service('paymentService', function (Request, GTM, $rootScope, info, selectedLanguage, utils) {
    var isLocalDev = _.find(
      ['localhost:9215'],
      function (str) {
        return _.includes(window.location.host, str);
      }
    );
    return {
      apiKey: info.checkoutComPublicKey,
      STRIPE_PP: 10,
      ADYEN_PP: 70,
      stripe: null,
      elements: null,
      card: null,
      iban: null,
      configuration: {
        locale: 'en_US',
        originKey: isLocalDev ? 'pub.v2.8015541893603266.aHR0cDovL2xvY2FsaG9zdDo5MjE1.wNjfC3uHg2aZyg3seqgAFHpZ1ZJi3S04GPMwhTcbtzQ' : info.adyenOriginKey,
        loadingContext: 'https://checkoutshopper-test.adyen.com/checkoutshopper/',
      },
      adyenCheckout: null,
      adyenState: null,
      defaultStyle: {
        base: {
          iconColor: '#1a1c23',
          color: '#1a1c23',
          fontSize: '14px',
          fontFamily: 'Gilroy, Helvetica, Open Sans, Segoe UI, sans-serif',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: '#B6B8B9',
          },
          ':-webkit-autofill': {
            color: '#B6B8B9',
          },
        },
        invalid: {
          iconColor: 'f23d4e',
          color: '#f23d4e',
        },
      },
      initStripe: function (callback) {
        var script = document.createElement('script'),
          _that = this;

        script.type = 'text/javascript';
        script.src = 'https://js.stripe.com/v3/';
        script.onload = function () {
          _that.stripe = Stripe(info.stripePublicKey);
          _that.elements = _that.stripe.elements({
            locale: selectedLanguage,
            fonts: [{ cssSrc: '/css/stripe-fonts.css' }],
          });

          window.stipe = _that.stripe;

          // window.Stripe.setPublishableKey(info.stripePublicKey);

          if (callback) {
            return callback();
          }
        };
        document.body.appendChild(script);
      },
      createPaymentForm: function () {
        $('.stripe-errors').removeClass('visible');

        if (this.card) { return true; }
        this.card = this.elements.create('card', {
          iconStyle: 'solid',
          hidePostalCode: true,
          style: this.defaultStyle,
        });

        this.card.mount('#card-number');

        var errorMessage = $('.stripe-errors');

        this.card.on('change', function (event) {
          // Handle real-time validation errors from the iban Element.
          if (event.error) {
            errorMessage.text(event.error.message);
            errorMessage.addClass('visible');
          } else {
            errorMessage.removeClass('visible');
          }
        });
      },
      createIbanForm: function () {
        // Create an instance of the iban Element.
        $('.stripe-errors').removeClass('visible');
        if (this.iban) { return true; }
        this.iban = this.elements.create('iban', {
          style: this.defaultStyle,
          supportedCountries: ['SEPA'],
        });

        // Add an instance of the iban Element into the `iban-element` <div>.
        this.iban.mount('#iban-element');

        var errorMessage = $('.stripe-errors'),
          bankName = $('#bank-name');

        this.iban.on('change', function (event) {
          // Handle real-time validation errors from the iban Element.
          if (event.error) {
            errorMessage.text(event.error.message); 
            errorMessage.addClass('visible');
          } else {
            errorMessage.removeClass('visible');
          }

          // Display bank name corresponding to IBAN, if available.
          if (event.bankName) {
            bankName.text(event.bankName);
            bankName.addClass('visible');
          } else {
            bankName.removeClass('visible');
          }
        });
      },
      cardDestroy: function () {
        if (!this.card) return false;
        this.card && this.card.destroy();

        return this.card = null;
      },
      prefillUser: function () {
        var user = $rootScope.user;
        if (user) {
          if (user.isStaff || _.get(user, 'affiliate.id')) {
            return {};
          }

          var obj = {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            country: user.countryId,
          };

          // if (user.billingAddress && user.billingAddress.phone) {
          //   obj.phone = user.billingAddress.phone || user.contactInformation.phone;
          // } else if (user.contactInformation && user.contactInformation.phone) {
          //   obj.phone = user.contactInformation.phone;
          // }

          if (user.contactInformation) {
            obj.phone = user.contactInformation.phone;
            obj.dateOfBirth = user.contactInformation.dob;

            obj.address = {
              zip: user.contactInformation.zipCode,
              city: user.contactInformation.city,
              state: user.contactInformation.state,
              street: user.contactInformation.address,
              country: user.contactInformation.country,
            };
          }

          return obj;
        }
        return {};
      },
      createToken: function (data, callback) {
        return this.stripe.createToken(this.card).then(callback);
      },
      createSource: function (callback) {
        var errorMessage = $('.stripe-errors');

        return this.stripe.createSource(this.card).then(function (result) {
          if (result.error) {
            // Inform the customer that there was an error.
            errorMessage.text(result.error.message);
            errorMessage.addClass('visible');
            callback(result);
          } else {
            // Send the Source to your server to create a charge.
            errorMessage.removeClass('visible');
            callback(result);
          }
        });
      },
      createSourceFromIban: function (data, callback) {
        var errorMessage = $('.stripe-errors'),
          sourceData = {
            type: 'sepa_debit',
            currency: 'eur',
            owner: {
              name: data.name,
              email: data.email,
            },
            mandate: {
              // Automatically send a mandate notification email to your customer
              // once the source is charged.
              notification_method: 'email',
            },
          };

        // Call `stripe.createSource` with the iban Element and additional options.
        return this.stripe.createSource(this.iban, sourceData).then(function (result) {
          if (result.error) {
            // Inform the customer that there was an error.
            errorMessage.text(result.error.message);
            errorMessage.addClass('visible');
            callback(result);
          } else {
            // Send the Source to your server to create a charge.
            errorMessage.removeClass('visible');
            callback(result);
          }
        });
        // return this.stripe.createSource(this.card, this.prefillUser()).then(callback);
      },
      getAffiliate: function (data) {
        return Request.get('booking/affiliate/autosuggest/', {
          search: data,
        }).then(function (res) {
          return res.data.results;
        });
      },
      getAffiliateCompaign: function (data, affiliateMemberNumber) {
        return Request.get('booking/affiliate/campaign/autosuggest/', {
          search: data,
          affiliate_profile__member_number: affiliateMemberNumber,
        }).then(function (res) {
          return res.data.results;
        });
      },
      getUserAccount: function (data) {
        return Request.get('account/suggest/', {
          search: data,
        }).then(function (res) {
          return res.data.results;
        });
      },
      getUserCC: function (id) {
        return Request.get('account/' + id + '/payment-methods/').then(function (res) {
          return res.data;
        });
      },
      confirm: function (uuid, data) {
        return Request.put('booking/checkout/' + uuid + '/confirm/', data).then(function (res) {
          return res.data;
        });
      },
      updatePaymentMethod: function (data) {
        return Request.put('checkout/orders/' + data.uuid + '/payment-method-update/', data).then(function (res) {
          return res.data;
        });
      },
      // ADYEN PART
      initAdyen: function () {
        var _this = this,
          script = document.createElement('script');

        script.type = 'text/javascript';
        script.src = 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/2.4.2/adyen.js';
        script.onload = function () {
          // Create a config object for SDK.
          _this.adyenCheckout = new AdyenCheckout(_this.configuration);
        };

        document.body.appendChild(script);
      },
      destroyAdyenCardForm: function () {
        this.card = null;
        $('#adyen-card-form').empty();
      },
      createAdyenCardForm: function () {
        var _this = this;

        $('.error-msg').removeClass('visible');
        if (_this.card) { this.destroyAdyenCardForm(); }
        _this.card = _this.adyenCheckout.create('card', {
          onChange: function (state, component) {
            _this.adyenState = state;
          },
        }).mount('#adyen-card-form');
      },
      getAdyenPaymentData: function () {
        if (this.adyenState && this.adyenState.isValid) {
          return this.adyenState.data;
        }
        return false;
      },
    };
  });
